module.exports = function capitalizeFirst(string) {
    return `${string[0].toUpperCase()}${string.slice(1)}`;
};
